import { Route, Routes } from "react-router-dom";
import Home from "./screens/Home";
import {Login, Register, MyPage, EditProfile, CompanyInfo} from './screens/user/index'
import {Cart, ItemRecommand, Order, ShopMain} from './screens/shop/index'
import {BoardList, BoardLook, BoardUpdate, BoardWrite} from './screens/board/index'
import { useCallback, useEffect, useState } from "react";
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { setAdmConfig, setBoardConfig, setCompanyInfoConfig, setShopDefaultConfig, setShopListMenuConfig } from "./redux/configSlice";
import { setUserInfo, setLogin } from "./redux/userSlice";
import DashboardMain from "./screens/dashboard/DashboardMain";
import OrderList from "./screens/shop/OrderList";
import OrderListDetail from "./screens/shop/OrderListDetail";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CheckPass from "./screens/user/CheckPass";
import { OrderSuccess } from "./screens/shop/shopdetail";
import mainPath from "./utils/path";
import RegisterSuccess from "./screens/user/RegisterSuccess";




function App() {
  const dispatch = useDispatch()
  const [admin, setAdmin] = useState(false)

  const getConfig = useCallback(async() => {
    try {
      const res = await axios.get('/api/adm/config/')

      if(!res.data.success){
        alert('연결이 실패하였습니다')
        window.history.back()
      }

      dispatch(setAdmConfig(res.data['admConfig']))
      dispatch(setBoardConfig(res.data['boardConfig']))
      dispatch(setCompanyInfoConfig(res.data['companyInfoConfig']))
      dispatch(setShopDefaultConfig(res.data['shopDefaultConfig']))
      dispatch(setShopListMenuConfig(res.data['shopListMenuConfig']))
    } catch (e) {
      console.log(e)
    }
  }, [])

  const getJwtAuth = useCallback(async() => {
    try {
      const res = await axios.get('/api/user/jwtAuthUser/')
      if(!res.data.success){
        dispatch(setLogin(false))
      }else{
        dispatch(setUserInfo(res.data.result))
        dispatch(setLogin(true))
      }
    } catch (e) {
      console.log(e)
    }
  }, [])


  useEffect(() => {
    window.scrollTo(0, 0);
    getConfig()
    getJwtAuth()
  }, [])



  return (
    <div className="App">
      {admin ? 
      <>
      <Routes>
        <Route path="/DashboardMain/*" element={<DashboardMain setAdmin={setAdmin} />} />
      </Routes>
      </>
      :
      <>
      <Header /> 
      <Routes>
        <Route path="/Login" element={<Login />} />
        <Route path="/Register" element={<Register />} />
        <Route path="/RegisterSuccess" element={<RegisterSuccess />} />
        <Route path="/MyPage" element={<MyPage />} />
        <Route path="/CheckPass" element={<CheckPass />} />
        <Route path="/EditProfile" element={<EditProfile />} />
        <Route path="/CompanyInfo" element={<CompanyInfo />} />
        <Route path="/ShopMain/*" element={<ShopMain />} />
        <Route path="/Cart" element={<Cart />} />
        <Route path="/Order" element={<Order />} />
        <Route path="/OrderSuccess" element={<OrderSuccess />} />
        <Route path="/ItemRecommand" element={<ItemRecommand />} />
        <Route path="/OrderList" element={<OrderList />} />
        <Route path="/OrderListDetail" element={<OrderListDetail />} />
        <Route path="/BoardList" element={<BoardList />} />
        <Route path="/BoardWrite" element={<BoardWrite />} />
        <Route path="/BoardLook" element={<BoardLook />} />
        <Route path="/BoardUpdate" element={<BoardUpdate />} />
        <Route path="/DashboardMain/*" element={<DashboardMain setAdmin={setAdmin} />} />
        <Route exact path="/" element={<Home />} />
      </Routes>
      <Footer />
      </>
      }
      
    </div>
  );
}

export default App;

